export const GROK_ASSISTANT_ENABLED = false;
